import { useTranslation } from 'react-i18next';

import { Button, ErrorIcon, cn } from '@/design-system';
import { isApiError } from '@/shared/api';

/** Region-level error: what failed, a retry, and a reference for support. Never a toast. */
export function ErrorPanel({ error, onRetry, className }: { error: unknown; onRetry?: () => void; className?: string }) {
  const { t } = useTranslation();
  const api = isApiError(error) ? error : null;
  const network = api?.isNetwork ?? false;
  return (
    <div role="alert" className={cn('flex items-start gap-3 border border-border bg-surface px-4 py-4', className)}>
      <ErrorIcon className="mt-0.5 text-negative" />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="text-body font-medium text-ink">{t('errors.title')}</p>
        <p className="text-body text-ink-secondary">{network ? t('errors.network') : api?.isForbidden ? t('errors.forbiddenAction') : t('errors.body')}</p>
        {api && api.traceId !== 'none' ? <p className="font-mono text-meta text-ink-muted select-all">{t('errors.reference', { traceId: api.traceId })}</p> : null}
        {onRetry ? (
          <div className="pt-1">
            <Button size="sm" onClick={onRetry}>
              {t('actions.retry')}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
